import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/cart-components/CartData.tsx");
